const key = process.env.REACT_APP_API_KEY;

const fetchNewsByLocation = async (gLocation) => {
    const url = `https://api.nytimes.com/svc/search/v2/articlesearch.json?fq=glocations%3A(%22${encodeURIComponent(gLocation)}%22)&sort=newest&api-key=${key}`;                
    const res = await fetch(url)
    const json = await res.json();
    const { docs } = json.response;

    return docs;
};

export default fetchNewsByLocation;